import Url from 'url-parse';

const queryParams = (() => {
  const search = Url.qs.parse(window.location.search);
  if (search.appId) {
    return search;
  } else {
    const hashQuery = window.location.hash.split('?')[1];
    const query = Url.qs.parse(hashQuery ? hashQuery : '');
    if (query.appId) {
      return {
        appId: query.appId
      };
    }
    return {};
  }
  // return Url.qs.parse(window.location.search);
})();

export default queryParams;
